// Copyright (c) Bentley Systems
import { ElField } from "./el-field";
import { ElHighlight } from "./el-highlight";
import { ElLayout } from "./el-layout";
import { Style } from "../../DataModels/style";
import { ElVariant } from "./el-variant";
import { ElCondinionRange } from "./el-condinion-range";

export class ElistStructureModel {
  public nodeId: number | undefined;
  public captionText: string | undefined;
  public isTile: boolean = false;
  public elActions: any[] = [];

  public elLayouts: ElLayout[] = [];
  public elConditionRanges: ElCondinionRange[] = [];
  public elFields: ElField[] = [];
  public elHighlights: ElHighlight[] = [];
  public otherStyles: Style[] = [];
  public filterParameterPrefix: string | undefined;
  public elVariants: ElVariant[] = [];
  public defaultVariant: ElVariant | undefined;
  public applAreaId: number | undefined;

  constructor(initializer?: any) {
    if (!initializer) {
      return;
    }
    if (initializer.nodeId) {
      this.nodeId = initializer.nodeId;
    }
    if (initializer.captionText) {
      this.captionText = initializer.captionText;
    }
    if (initializer.isTile && initializer.isTile === true) {
      this.isTile = true;
    }
    if (initializer.elActions) {
      this.elActions = initializer.elActions;
    }
    if (initializer.elLayouts) {
      this.elLayouts = initializer.elLayouts;
    }
    if (initializer.elConditionRanges) {
      this.elConditionRanges = initializer.elConditionRanges;
    }
    if (initializer.elFields) {
      this.elFields = initializer.elFields;
    }
    if (initializer.elHighlights) {
      this.elHighlights = initializer.elHighlights;
    }
    if (initializer.otherStyles) {
      this.otherStyles = initializer.otherStyles;
    }
    if (initializer.filterParameterPrefix) {
      this.filterParameterPrefix = initializer.filterParameterPrefix;
    }
    if (initializer.elVariants) {
      this.elVariants = initializer.elVariants;
    }
    if (initializer.applAreaId) {
      this.applAreaId = initializer.applAreaId;
    }

    if (this.elVariants.length > 0) {
      this.defaultVariant = this.elVariants.reduce((aVar, bVar) =>
        (aVar.variantOrder as number) < (bVar.variantOrder as number)
          ? aVar
          : bVar,
      );
    }
  }
}
